import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';
import { StyledIcon } from '../../RoundIcon/styles';

export const StyledIconLinkList = styled.div`
  display: grid;
  grid-row-gap: ${themeGet('scale.scaleUp03')};

  ${StyledIcon} {
    background: ${themeGet('color.colorGrayBlue30')};

    path {
      fill: ${themeGet('color.colorGrayBlue70')};
    }
  }

  > div {
    display: grid;
    grid-template-columns: ${themeGet('scale.scaleUp05')} auto;
    grid-column-gap: ${themeGet('scale.scaleDown03')};
    align-items: center;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: ${themeGet('breakpoint.breakpointNavMd')}) {
    grid-template-columns: 1fr;
    grid-row-gap: ${themeGet('scale.scaleBase')};
    margin-top: -${themeGet('scale.scaleDown03')};
  }
`;

export const StyledCta = styled.div`
  margin-top: ${themeGet('scale.scaleUp05')};
`;

export default StyledIconLinkList;
